export default __webpack_public_path__ + "static/media/benefit_2.8f6ec8b2.png";